import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrows-exchange', 'IconArrowsExchange', [["path",{"d":"M7 10h14l-4 -4","key":"svg-0"}],["path",{"d":"M17 14h-14l4 4","key":"svg-1"}]]);